"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = 'M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM6.85982 11.7682L11.1197 15.3182C11.6297 15.7431 12.3703 15.7431 12.8803 15.3182L17.1402 11.7682C17.5645 11.4147 17.6218 10.7841 17.2682 10.3598C16.9147 9.93554 16.2841 9.87821 15.8598 10.2318L12 13.4483L8.14018 10.2318C7.71591 9.87821 7.08534 9.93554 6.73178 10.3598C6.37821 10.7841 6.43554 11.4147 6.85982 11.7682Z';